export { LanguageSelectorComponent } from './language-selector.component';



// WEBPACK FOOTER //
// ./src/app/shared/i18n/language-selector/index.ts